import { ApiResponse } from "../models";
import * as http from "./http";
import ApiService from "./service";
import { GenericDocuments, PaginatedApiResponse } from "../..";
import {
  DashboardEntitiesCount,
  InventoryData,
  StatisticsData,
  CompanyDirectory,
} from "../models/dashboard";

export class DashboardService extends ApiService {
  public async getDashboardTotals(data: {
    salesManId?: string;
    fromDate?: Date;
    toDate?: Date;
    showroomIds?: string[];
    salesManIds?: string[];
    hasCreatedByFilter?: boolean;
    createdById?: (string | undefined)[];
    createdBy?: (string | undefined)[];
    cityKeyID?: string;
    propertyTypeKey?: string;
  }) {
    const url = `${this.apiDomain}/api/dashboard/salesman`;

    const resposne = await http.post<ApiResponse<DashboardEntitiesCount>>(
      url,
      data,
      this.store
    );
    return resposne?.data?.data;
  }

  public async getDashboardInventory(data: {
    cityKeyID?: string;
    propertyTypeKey?: string;
  }) {
    const url = `${this.apiDomain}/api/property/inventory/dashboard`;

    const resposne = await http.post<ApiResponse<InventoryData>>(
      url,
      data,
      this.store
    );
    return resposne?.data?.data;
  }

  public async getStatistics(data: {
    salesManId?: string;
    fromDate?: Date;
    toDate?: Date;
    showroomIds?: string[];
    salesManIds?: string[];
    hasCreatedByFilter?: boolean;
    createdById?: (string | undefined)[];
    createdBy?: (string | undefined)[];
    stageCode?: string;
    cityKeyID?: string;
    propertyTypeKey?: string;
  }) {
    const url = `${this.apiDomain}/api/dashboard/statistics`;

    const resposne = await http.post<ApiResponse<StatisticsData>>(
      url,
      data,
      this.store
    );
    return resposne?.data?.data;
  }

  public async getLocationBasedAvailability(data: {
    cityKeyID?: string;
    propertyTypeKey?: string;
    page?: number;
    limit?: number;
    query?: string;
  }) {
    const url = `${this.apiDomain}/api/property/inventory/dashboard/city`;

    const resposne = await http.post<ApiResponse<InventoryData>>(
      url,
      data,
      this.store
    );
    return resposne?.data?.data;
  }

  public async listCompaniesForDashboard(data: {
    page: number;
    perPage: number;
    fromDate?: Date;
    toDate?: Date;
    salesManId?: string;
    salesManIds?: string[];
    sortBy?: string;
    sortOrder?: string;
    query?: string;
    cityName?: string;
    propertyTypeKey?: string;
  }) {
    const url = `${this.apiDomain}/api/company/dashboard/company-directory`;

    const resposne = await http.post<PaginatedApiResponse<CompanyDirectory>>(
      url,
      data,
      this.store
    );
    return resposne?.data;
  }

  public async listDocuments(data: {
    page: number;
    perPage: number;
    sortBy?: string;
    sortOrder?: string;
    query?: string;
    documentIds?: string[];
  }) {
    const url = `${this.apiDomain}/api/proposal-document/list-dashboard`;

    const resposne = await http.post<PaginatedApiResponse<GenericDocuments>>(
      url,
      data,
      this.store
    );
    return resposne?.data;
  }

  public async listSiteVisit(data: {
    page: number;
    perPage: number;
    sortBy?: string;
    sortOrder?: string;
    query?: string;
    siteVisitIds?: string[];
  }) {
    const url = `${this.apiDomain}/api/siteVisit/list-dashboard`;

    const resposne = await http.post<PaginatedApiResponse<GenericDocuments>>(
      url,
      data,
      this.store
    );
    return resposne?.data;
  }
}
